import { Box, Divider, Typography } from "@mui/material";
import { useLocation, useParams } from "react-router-dom";
import { track } from "../../logic";
import { useGetNotification, useGetOrder } from "../../logic/useApiQuery";
import { LoadingScreen } from "../shared";
import { checkIfPastDue, formatDate, isTaskNotificationType } from "../../utils";
import { SanitizedHtml } from "../shared/SanitizedHtml";
import { PortalTaskComponent } from '../shared/PortalTaskComponent';
import { NotificationPagination } from "../shared/NotificationPagination";
import { useNotificationContentOverride } from "../context/notification-content-override/NotificationContentOverrideContext";
import dayjs from "dayjs";
import { isAdhocPortalOrder } from "../../utils/isAdhocPortalOrder";


export function NotificationPage() {
  const { closingId } = useParams()
  const { search } = useLocation()
  const { data: notification, error, isLoading } = useGetNotification()
  const { data: globalOrderData } = useGetOrder(closingId ?? '', search ?? '')

  const { notificationContentOverride } = useNotificationContentOverride();

  if (isLoading) {
    return <LoadingScreen />
  } else if (error) {
    console.error('Error fetching notification:', error)
    track('error', 'useGetNotification', {}, {
      message: JSON.stringify(error),
      component: 'NotificationPage',
    })

    throw error
  }

  const date = formatDate({ dateLike: notification.CreatedDate }) || ''
  const showDueDate = notification.Type === 'CashToCloseTask' && !notification.IsComplete
  const cashToCloseDueDate = globalOrderData && !isAdhocPortalOrder(globalOrderData.Order) ? dayjs(globalOrderData?.Order?.CashToCloseDetails?.dueDate).format('dddd, MMMM D, YYYY [at] hh:mm A z') : null
  const pastDue = globalOrderData && !isAdhocPortalOrder(globalOrderData.Order) && !notification?.IsComplete && notification.Type === 'CashToCloseTask' && !!globalOrderData?.Order?.CashToCloseDetails?.dueDate && checkIfPastDue(globalOrderData?.Order.CashToCloseDetails.dueDate)


  const { Form } = notification

  const showTaskComponent = isTaskNotificationType(notification.Type)


  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
      <Typography variant="h5" sx={{ fontWeight: '500', lineHeight: '22px', m: 1, mb: 2, wordBreak: 'break-word' }}>
        {notification.Title || Form?.DisplayName || ''}
      </Typography>
      <Divider />
      <Box sx={{mb: 3}} flexDirection="column" display="flex">
        <Typography variant="light" fontSize="small" sx={{ mt: 2, ml: 1 }}>
        Created date: {date}
        </Typography>
        { showDueDate && <Typography variant="light" fontSize="small" sx={{ mt: 0, ml: 1, color: 'black', fontWeight: 'bold' }}>
        Due date: {cashToCloseDueDate}
        </Typography> }
      </Box>
      {!!notification.Content && !notification.IsComplete && !pastDue && (
        <Typography sx={{ pl: 1, pr: 1, wordBreak: 'break-word', pb: 2 }}>
          <SanitizedHtml html={notificationContentOverride ?? notification.Content} />
        </Typography>
      )}

      {
        showTaskComponent ?

          <Box sx={{ m: 1 }}>
            <PortalTaskComponent />
          </Box>

          :

          // Convenience button for next unread message. If there's a form/task, the forms component handles this separately
          <NotificationPagination />
      }

    </Box>
  )
}
